export const downloadHistoryListingConstants = {
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
    GETALLDOWNLOADHISTORYLISTING_REQUEST: 'GETALLDOWNLOADHISTORYLISTING_REQUEST',
    GETALLDOWNLOADHISTORYLISTING_REQUEST_END: 'GETALLDOWNLOADHISTORYLISTING_REQUEST_END',

    GETALLDOWNLOADHISTORYLISTING_SUCCESS: 'GETALLDOWNLOADHISTORYLISTING_SUCCESS',
    GETALLDOWNLOADHISTORYLISTING_FAILURE: 'GETALLDOWNLOADHISTORYLISTING_FAILURE'
};